import { getHandler } from 'src/utils/fetchHandler';

export const GET_FUNDRAISER_ASSIGNMENT_TYPES =
	'GET_FUNDRAISER_ASSIGNMENT_TYPES/FUNDRAISER_ASSIGNMENT_TYPES/@WISELY/WEB';
export const FETCH_FUNDRAISER_ASSIGNMENT_TYPES_FAILED =
	'FETCH_FUNDRAISER_ASSIGNMENT_TYPES_FAILED/FUNDRAISER_ASSIGNMENT_TYPES/@WISELY/WEB';
export const FETCH_FUNDRAISER_ASSIGNMENT_TYPES_SUCCEEDED =
	'FETCH_FUNDRAISER_ASSIGNMENT_TYPES_SUCCEEDED/FUNDRAISER_ASSIGNMENT_TYPES/@WISELY/WEB';

export const getFundraiserAssignmentTypes = () => ({
	type: GET_FUNDRAISER_ASSIGNMENT_TYPES,
});

export const fetchFundraiserAssignmentTypesSucceeded = payload => ({
	type: FETCH_FUNDRAISER_ASSIGNMENT_TYPES_SUCCEEDED,
	payload,
});

export const fetchFundraiserAssignmentTypesFailed = payload => ({
	type: FETCH_FUNDRAISER_ASSIGNMENT_TYPES_FAILED,
	payload,
});

export const fetchFundraiserAssignmentTypes = () => {
	return dispatch => {
		dispatch(getFundraiserAssignmentTypes());
		const path = `v2/fundraiser_assignment_types`;

		return getHandler(path)
			.then(json => dispatch(fetchFundraiserAssignmentTypesSucceeded(json)))
			.catch(error => {
				console.error('fetchFundraiserAssignmentTypes error', error);
				dispatch(fetchFundraiserAssignmentTypesFailed(error));
			});
	};
};



// WEBPACK FOOTER //
// ./src/redux/fundraiserAssignmentTypes/fundraiserAssignmentType.action.js